// Common honeybee species & subspecies for the hive form Select.
// Free text is still allowed at the API layer so beekeepers with unusual
// stock (regional ecotypes, breeders' lines) can override via direct edit.

export const SPECIES_OPTIONS = [
  { group: "Apis mellifera (Western honeybee)", items: [
    { value: "Italian (A. m. ligustica)",      label: "Italian — A. m. ligustica" },
    { value: "Carniolan (A. m. carnica)",      label: "Carniolan — A. m. carnica" },
    { value: "Buckfast",                       label: "Buckfast" },
    { value: "Russian",                        label: "Russian" },
    { value: "Saskatraz",                      label: "Saskatraz" },
    { value: "Caucasian (A. m. caucasica)",    label: "Caucasian — A. m. caucasica" },
    { value: "Dark European (A. m. mellifera)", label: "Dark European — A. m. mellifera" },
    { value: "Iberian (A. m. iberiensis)",     label: "Iberian — A. m. iberiensis" },
    { value: "African (A. m. scutellata)",     label: "African — A. m. scutellata" },
    { value: "Africanized hybrid",             label: "Africanized hybrid" },
    { value: "Local mutt",                     label: "Local mutt / open-mated" },
  ]},
  { group: "Other honeybees", items: [
    { value: "Asian (Apis cerana)",            label: "Asian — Apis cerana" },
    { value: "Giant (Apis dorsata)",           label: "Giant — Apis dorsata" },
    { value: "Dwarf (Apis florea)",            label: "Dwarf — Apis florea" },
  ]},
  { group: "Stingless bees", items: [
    { value: "Stingless (Meliponini)",         label: "Stingless — Meliponini sp." },
  ]},
];

// Quick flat list of values for "is custom?" detection (when editing existing hives
// whose species don't match any preset, we render an "Other" mode with a text input).
export const SPECIES_VALUES = SPECIES_OPTIONS.flatMap((g) => g.items.map((i) => i.value));

export const SPECIES_OTHER = "__other__";
